import { Component, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SaturedChipComponent, VerySaturedChipComponent } from "../../chips";

@Component({
  selector: 'app-card-1',
  standalone: true,
  imports: [
    TranslateModule,
    SaturedChipComponent,
    VerySaturedChipComponent
],
  templateUrl: './card-1.component.html',
  styleUrls: ['./card-1.component.scss'],
  host: {
    style: 'display: block; width: 100%; height: 100%;'
  }
})
export class Card1Component {
  public indexCard: InputSignal<number> = input.required<number>();
  public id: InputSignal<number> = input<number>();
  public title: InputSignal<string> = input.required<string>()
  public img: InputSignal<string> = input.required<string>();
  public isSaturated: InputSignal<boolean> = input<boolean>(false); 
  public isVerySaturated: InputSignal<boolean> = input<boolean>(false);
  public numberOfPoints: InputSignal<number> = input<number>(1);
}
